import type { BrowserProductQueryQuery } from '@generated/graphql'
import React, { useState } from 'react'
import AddToWishlistModal from 'src/components/modal/AddToWishlistModal'
import SingleInputModal from 'src/components/modal/SingleInputModal'
import { useWishlistContext } from 'src/contexts/WishlistContext/wishlist-context'

import type { ProductType } from './ProductCardTypes'

interface IHandleModalSaveProductAndWishlist {
  product: BrowserProductQueryQuery['product'] | ProductType
}

export default function HandleModalSaveProductAndWishlist({
  product,
}: IHandleModalSaveProductAndWishlist) {
  const [isSaveProductModalOpen, setIsSaveProductModalOpen] = useState(false)
  const [isCreateWishlistModalOpen, setIsCreateWishlistModalOpen] =
    useState(false)

  const { createWishlist } = useWishlistContext()

  return (
    <>
      {isSaveProductModalOpen && (
        <AddToWishlistModal
          products={[{ ...product }]}
          product={product}
          isOpen={isSaveProductModalOpen}
          setIsOpen={setIsSaveProductModalOpen}
          openWishlistModal={() => setIsCreateWishlistModalOpen(true)}
        />
      )}
      {isCreateWishlistModalOpen && (
        <SingleInputModal
          title="Dê um nome para sua lista"
          btnText="Salvar"
          isOpen={isCreateWishlistModalOpen}
          setIsOpen={setIsCreateWishlistModalOpen}
          modalAction={createWishlist}
          setIsSaveProductModalOpen={setIsSaveProductModalOpen}
          onClose={() => setIsSaveProductModalOpen(true)}
        />
      )}
    </>
  )
}
